import { ThunkType } from "../../../../core/store/reducers";
import getEtfPerformanceApi from "../api/getEtfPerformance";
import { setDisplayedEtfPerformance } from "../statisticsDataSlice";
import { EtfPerformanceItem } from "../types";

const periodLabel = (p: string) =>
	({
		ytd: "YTD",
		"1_month": "1 mesec",
		"3_month": "3 meseca",
		"1_year": "1 godina",
		"3_year": "3 godine",
		"5_year": "5 godina",
		"10_year": "10 godina",
	} as Record<string, string>)[p] ?? p;



export const loadEtfPerformance = (symbol: string): ThunkType => async (dispatch) => {

	dispatch(setDisplayedEtfPerformance(undefined));

	const etfperformance = await dispatch(getEtf_Performance(symbol)
	);

	dispatch(setDisplayedEtfPerformance(etfperformance));
};

export const getEtf_Performance = (
	symbol: string
): ThunkType<Promise<EtfPerformanceItem | undefined>> =>
	async (dispatch, getStore, _extra) => {

		const store = getStore();

		if (store.data.auth.current.status !== "successful") {
			return undefined;
		}
		const { userId } = store.data.auth.current.user;

		const response = await dispatch(
			getEtfPerformanceApi(userId, symbol, "etfs/world/performance")
		);

		if (!response?.etf?.performance) {
			return undefined;
		}

		const perf = response.etf.performance;
		const rows =
			perf.trailing_returns?.map(tr => ({
				period: periodLabel(tr.period),
				shareClassReturn: tr.share_class_return,
				categoryReturn: tr.category_return,
			})) ?? [];

		const annualRows =
			perf.annual_total_returns?.map(ar => ({
				period: `Godišnji ukupni prihod (${ar.year})`,
				shareClassReturn: ar.share_class_return,
				categoryReturn: ar.category_return,
			})) ?? [];

		return { symbol, rows: [...rows, ...annualRows] };
	};